/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { RunbookStatus } from "./RunbookStatus";
import { RunbookConfig } from "./RunbookConfig";
export const UpdateRunbookRequest = core.serialization.object({
    name: core.serialization.string().optional(),
    status: RunbookStatus.optional(),
    config: RunbookConfig.optional(),
});
